import React from 'react';
import moment from 'moment';
import { Row } from 'react-grid-system';
import useTranslate from '@Utils/hooks/useTranslate';
import { BoldText, PickupInfo } from './../ShippingMethod.styled';

interface IPickupInformation {
	launchDate: string | undefined;
}

const PickupInformation = ({ launchDate }: IPickupInformation): JSX.Element => {
	const { translate } = useTranslate();
	return (
		<Row>
			<PickupInfo>
				{translate('shipping-method.pickup-info-1')}
				<BoldText>{translate('shipping.method.omante.hq')}</BoldText>
				{translate('shipping-method.pickup-info-2')}
				<BoldText>{moment(launchDate).format('DD MMM YYYY')}.</BoldText>
				{translate('shipping-method.pickup-info-3')}
			</PickupInfo>
		</Row>
	);
};

export default PickupInformation;
